import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react-lite';
import {
  HeaderContent,
  DateContainer,
  TimeContainer,
  RadioWrapper,
} from './call-courier-with-sidebar.styles';
import Spinner from '../../../common/spinner/spinner.component';
import { HeaderDivider } from '../../header/header-user/header-user.styles';
import CustomRadioButton from '../../../common/radio-button/custom-radio-button.component';
import { formatDisplayDate, formatDisplayTime } from './helpers';
import {
  PickupDateTimeSlots,
  TimeSlot,
} from '../../../models/pickupWindowsModels';
import { CourierPickupSlot } from '../../../models/parcelDeliveryMiles';

interface Props {
  pickupSlots: PickupDateTimeSlots[] | undefined;
  selectedPickupInfo: CourierPickupSlot | undefined;
  isLoading: boolean;
  hideDivider?: boolean;
  onDateChange: (date: string) => void;
  onTimeChange: (timeSlot: TimeSlot) => void;
}

const CallCourierForm = ({
  pickupSlots,
  selectedPickupInfo,
  isLoading,
  hideDivider,
  onDateChange,
  onTimeChange,
}: Props) => {
  const { t } = useTranslation();

  const dates =
    pickupSlots?.map(({ date }) => ({
      original: date,
      display: formatDisplayDate(date, t),
    })) || [];

  const timeSlots =
    pickupSlots?.find(
      (pickupSlot) => pickupSlot.date === selectedPickupInfo?.date
    )?.time_slots || [];

  if (isLoading || !pickupSlots) {
    return <Spinner />;
  }

  return (
    <>
      <DateContainer>
        <HeaderContent>{t('create_parcel_courier_date')}</HeaderContent>
        <RadioWrapper>
          {dates.map((date) => (
            <CustomRadioButton<string>
              key={date.original}
              name='courierDate'
              value={date.original}
              label={date.display}
              isSelected={date.original === selectedPickupInfo?.date}
              onSelect={onDateChange}
            />
          ))}
        </RadioWrapper>
      </DateContainer>

      {!hideDivider && <HeaderDivider />}

      <TimeContainer>
        <HeaderContent>{t('create_parcel_courier_time')}</HeaderContent>
        <RadioWrapper>
          {timeSlots.map((slot) => (
            <CustomRadioButton<TimeSlot>
              key={slot.from}
              name='courierTime'
              value={slot}
              label={formatDisplayTime(slot.from, slot.to)}
              isSelected={
                slot.from === selectedPickupInfo?.time_from &&
                slot.to === selectedPickupInfo.time_to
              }
              onSelect={onTimeChange}
            />
          ))}
        </RadioWrapper>
      </TimeContainer>
    </>
  );
};

export default observer(CallCourierForm);
